<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ honoraires?.length || 0 }} honoraire(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addHonoraire()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Code</th>
          <th>Type</th>
          <th>Libellé</th>
          <th>Périodicité</th>
          <th>Mode</th>
          <th>Montant</th>
          <th>Payé</th>
          <th>État</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of honoraires">
          <td>{{ item?.code }}</td>
          <td><span class="badge badge-info">{{ item?.type }}</span></td>
          <td>{{ item?.libelle }}</td>
          <td>{{ item?.periodicite }}</td>
          <td>{{ item?.modeCalcul }}</td>
          <td class="text-right">{{ item?.montant | number:'1.0-0' }} FCFA</td>
          <td class="text-right">{{ item?.montantPaye | number:'1.0-0' }} FCFA</td>
          <td>
            <span class="badge" [ngClass]="{
              'badge-secondary': item?.etat === 'BROUILLON',
              'badge-primary': item?.etat === 'VALIDE',
              'badge-success': item?.etat === 'PAYE',
              'badge-danger': item?.etat === 'ANNULE'
            }">{{ item?.etat }}</span>
          </td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editHonoraire(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteHonoraire(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
